import { useQuery } from 'react-query';
import { announcementService } from 'services';
import { TextAnnouncement, BannerAnnouncement } from 'shared';

const DELAY_IN_MS = 10 * 1000;

const Announcements: React.FC = () => {
  const { data: announcement } = useQuery(['announcement'], () => announcementService.getAnnouncement(), {
    retry: 2,
    retryDelay: DELAY_IN_MS
  });

  if (announcement?.banner) {
    return <BannerAnnouncement {...announcement.banner} />;
  }

  if (announcement?.alert) {
    return <TextAnnouncement {...announcement.alert} id={announcement.id} />;
  }

  return null;
};

export default Announcements;
